import { forwardRef } from "react";
import { Link as RouterLink, LinkProps } from "react-router";
import { useParams } from "react-router";
import { useWorkspaceStore } from "@/store/workspace-store";

interface WorkspaceLinkProps extends Omit<LinkProps, "to"> {
  to: string;
  forceWorkspaceId?: string;
}

export const WorkspaceLink = forwardRef<HTMLAnchorElement, WorkspaceLinkProps>(
  function WorkspaceLink({ to, forceWorkspaceId, className, ...props }, ref) {
    const { workspaceId } = useParams<{ workspaceId: string }>();
    const { activeWorkspace } = useWorkspaceStore();

    // Use forced workspace ID, then URL param, then active workspace
    const currentWorkspaceId = forceWorkspaceId || workspaceId || activeWorkspace?._id;

    if (!currentWorkspaceId) {
      // No workspace available, link to workspaces list
      return <RouterLink ref={ref} to="/workspaces" className={className} {...props} />;
    }

    // Ensure path starts with /
    const normalizedPath = to.startsWith("/") ? to : `/${to}`;
    const workspacePath = `/${currentWorkspaceId}${normalizedPath}`;

    return <RouterLink ref={ref} to={workspacePath} className={className} {...props} />;
  }
);
